var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-img"},[_c('img',{attrs:{"src":_vm.fileBaseUrl + _vm.contentData.salesImage}})]),_c('div',{staticClass:"sales-desc"},[_vm._v(" "+_vm._s(_vm.contentData.salesContent)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }